import LoadableLoading from "@components/Loading/LoadbleLoader";
import React, { lazy, Suspense } from "react";

const loadable = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(importFunc);

  return (props) => (
    <Suspense fallback={fallback || <LoadableLoading />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;

export const PublicLoadable = (
  importFunc,
  { fallback = null } = { fallback: null }
) => {
  const LazyComponent = lazy(importFunc);

  return (props) => (
    <Suspense fallback={fallback || <LoadableLoading />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};
